import { useState } from "react";
import { ASSETS } from "#/lib/assets";
import { ArrowBtn, Stars } from "../primitives.js";

interface Testimonial {
  name: string;
  rating: number;
  when: string;
  body: string;
  img: string;
  link: string;
}

const TESTIMONIALS: readonly Testimonial[] = [
  {
    img: "https://lh3.googleusercontent.com/a/ACg8ocL5Kj7SaX3HgVNyCw0wu5cxQqzZfBKBOdDMkNKUu1DUndeoOYg=w72-h72-p-rp-mo-br100",
    name: "Lyn May T. Rivera",
    rating: 5,
    when: "8 months ago",
    body: "I had an excellent experience with Learning Plus when I had a problem with my order and they were prompt in resolving the issue. After 48 hours the issue was resolved. Grateful to their staff for the seamless transaction. I highly appreciate the excellent service. Thank you so much. ",
    link: "https://share.google/hXgrho2bBmKPC00LZ",
  },
  {
    img: "https://lh3.googleusercontent.com/a-/ALV-UjVXfSc823pa5G1YGGYr4fRTJR3Df00WZ5IKH4nmkO9YDtiNmjnkBA=w72-h72-p-rp-mo-br100",
    name: "Roselle",
    rating: 5,
    when: "9 months ago",
    body: "They have a wide selection of excellent homeschool books. My order arrived the day after payment, and was neatly and securely packed. I definitely had a great experience with this site.",
    link: "https://share.google/YO2QtZzvCEjHAJx4u",
  },
  {
    img: "https://lh3.googleusercontent.com/a/ACg8ocIT3m3a4jfTovL7yGoZgIvCwwJToFqp6cQy22qyXc9slxqZSw=w72-h72-p-rp-mo-br100",
    name: "Everjoy Reyes",
    rating: 5,
    when: "10 months ago",
    body: "Home School is the best for us! We love Home School Global!!!",
    link: "https://share.google/8Wkbbcmujq0mez3Dw",
  },
  {
    img: "https://lh3.googleusercontent.com/a-/ALV-UjV7snoHQ_lcrcslz4rwevpwF2tVvE5Q5NmH0p348Lp1K2lsopc=w72-h72-p-rp-mo-br100",
    name: "Wendi",
    rating: 5,
    when: "a year ago",
    body: "easy to navigate. fast and secured delivery.",
    link: "https://share.google/CINdLLPSvcZIsj7Ls",
  },
  {
    img: "https://lh3.googleusercontent.com/a-/ALV-UjUqDceQRXTVoXzpe4UGk8rzKcV_Lq-_5YGhiRK2RAjx6gm6dQFz=w72-h72-p-rp-mo-br100",
    name: "Anna Castro",
    rating: 5,
    when: "a year ago",
    body: "Our purchase of my son's curriculum books were so fast and smooth. If we are just at home, they will also deliver the items, same day upon confirmation of our payment",
    link: "https://share.google/ghLljWVxhaS2uWfu5",
  },
  {
    img: "https://lh3.googleusercontent.com/a-/ALV-UjUPVGbx_ul1ySMIqy4_wsVvtrSPKAu1y2WWu1BKVj5QT293mCPuXA=w72-h72-p-rp-mo-br100",
    name: "Katriz Pascual",
    rating: 5,
    when: "a year ago",
    body: "Great place to get your homeschooling books from. Great service as well.",
    link: "https://share.google/iaQmiqLmNDc7DdC5F",
  },
];

export function Testimonials() {
  const [i, setI] = useState(0);
  const total = TESTIMONIALS.length;
  const r = TESTIMONIALS[i] ?? TESTIMONIALS[0];
  if (!r) return null;

  return (
    <section className="relative bg-[#ABD79D] pt-12 md:pt-24">
      <div className="bg-white rounded-t-[40px] md:rounded-t-[80px] pt-10 md:pt-24 pb-12 md:pb-20">
        <div className="max-w-6xl mx-auto px-4 md:px-10">

          <div className="text-center mb-10 md:mb-16">
            <h2 className="m-0 font-display font-bold text-3xl md:text-5xl text-[#6F6E6E] tracking-wider uppercase">
              OUR HAPPY CUSTOMERS
            </h2>
          </div>

          <hr className="border-t-2 border-[#89AC7E] mb-12 md:mb-20 w-full" />

          {/* Carousel */}
          <div className="flex items-center gap-3 md:gap-6 max-w-3xl mx-auto">
            <ArrowBtn
              dir="left"
              size={40}
              variant="filled"
              onClick={() => setI((x) => (x - 1 + total) % total)}
            />

            {/* Card */}
            <div
              key={`card-${i}`}
              className="flex-1 bg-[#f7faf6] border border-[#d4eacf] rounded-3xl px-6 py-8 md:px-10 md:py-10 shadow-sm animate-in fade-in slide-in-from-bottom-2 duration-[420ms] ease-bju"
            >
              {/* Quote mark */}
              <div className="text-[#ABD79D] mb-5 md:mb-6">
                <svg width="40" height="30" viewBox="0 0 40 30" fill="currentColor" aria-hidden="true">
                  <path d="M0 30V18.182C0 7.727 6.364 1.818 19.091 0l1.818 3.636C14.545 5.455 11.364 9.09 10.909 14.545H18.18V30H0zm21.818 0V18.182C21.818 7.727 28.182 1.818 40.909 0l1.818 3.636C36.364 5.455 33.182 9.09 32.727 14.545H40V30H21.818z" />
                </svg>
              </div>

              {/* Review body */}
              <p className="m-0 font-display text-base md:text-xl text-gray-700 leading-relaxed mb-8 md:mb-10">
                {r.body}
              </p>

              {/* Divider */}
              <div className="border-t border-[#d4eacf] mb-6" />

              {/* Reviewer row */}
              <div className="flex items-center gap-3">
                <img
                  src={r.img}
                  alt={r.name}
                  loading="lazy"
                  decoding="async"
                  className="size-10 rounded-full border border-[#c8e3c2] shrink-0"
                />

                {/* Name + date */}
                <div className="flex-1 min-w-0">
                  <p className="m-0 font-display font-semibold text-sm md:text-base text-gray-800 leading-tight truncate">
                    {r.name}
                  </p>
                  <p className="m-0 font-display text-xs text-gray-600 mt-0.5">
                    {r.when}
                  </p>
                </div>

                {/* Stars */}
                <div className="shrink-0">
                  <Stars rating={r.rating} size={18} />
                </div>

                {/* Google logo link */}
                <a
                  href={r.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="shrink-0 transition-transform hover:scale-110 duration-200"
                  title="View on Google"
                >
                  <img
                    src={ASSETS.google}
                    alt="Google"
                    loading="lazy"
                    decoding="async"
                    className="size-7 object-contain"
                  />
                </a>
              </div>
            </div>

            <ArrowBtn
              dir="right"
              size={40}
              variant="filled"
              onClick={() => setI((x) => (x + 1) % total)}
            />
          </div>

          {/* Pagination dots */}
          <div className="flex justify-center gap-2 mt-8">
            {TESTIMONIALS.map((_, idx) => (
              <button
                type="button"
                key={idx}
                onClick={() => setI(idx)}
                aria-label={`Go to review ${idx + 1}`}
                className="flex h-6 w-6 shrink-0 items-center justify-center"
              >
                <span
                  className={`block h-2 rounded-full transition-all duration-300 ${
                    idx === i
                      ? "w-6 bg-[#89AC7E]"
                      : "w-2 bg-[#c8e3c2] hover:bg-[#a8cf9e]"
                  }`}
                />
              </button>
            ))}
          </div>

          <hr className="border-t-2 border-[#89AC7E] mt-12 md:mt-20 w-full" />

          <div className="mt-12 md:mt-16 flex justify-center">
            <a
              href="https://www.google.com/maps/place/Learning+Plus+Fulfillment+%26+Warehouse+Center/@14.6094515,121.090922,17z/data=!4m8!3m7!1s0x3397c99ea58cf303:0x7b71889441185a3c!8m2!3d14.6094515!4d121.0934969!9m1!1b1!16s%2Fg%2F11j3t0w62m?hl=en-US&entry=ttu&g_ep=EgoyMDI2MDUxNy4wIKXMDSoASAFQAw%3D%3D#:~:text=Overview-,Reviews,-About"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-10 md:px-16 py-3 md:py-4 font-display font-semibold text-white bg-[#ABD79E] hover:bg-[#45553F] rounded-full duration-500 ease-in-out transition-all text-sm md:text-base"
            >
              Leave a Review
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
